import { Box } from "@strapi/design-system"
import { customPreviewImage, MODEL_IMAGES } from "./types"
import { useAppSelector } from "hooks/storeHooks"

interface PreviewOverlayImageSelectorProps {
  image: string
  onChange: (url: string) => void
  onOpenAddCustomImageModal: () => void
  onRemoveCustomImage?: (isActive: boolean) => void
}

export const PreviewOverlayImageSelector = ({
  image,
  onChange,
  onOpenAddCustomImageModal,
  onRemoveCustomImage,
}: PreviewOverlayImageSelectorProps) => {
  const customPhoto = useAppSelector((state) => state.user.customPhoto)

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 8,
        position: "relative",
      }}
    >
      {MODEL_IMAGES.map((url) => (
        <Box
          key={url}
          onClick={() => {
            onChange(url)
          }}
          style={{
            display: "flex",
            border: "2px solid",
            borderColor: url === image ? "#4945ff" : "#eaf5ff",
            borderRadius: 8,
            padding: 2,
            cursor: "pointer",
            position: "relative",
          }}
        >
          <img
            src={url}
            alt="Model"
            width={35}
            height={35}
            style={{ borderRadius: 4, objectFit: "cover" }}
          />
        </Box>
      ))}

      {customPhoto ? (
        <Box
          style={{
            display: "flex",
            border: "2px solid",
            borderColor: customPhoto === image ? "#4945ff" : "#eaf5ff",
            borderRadius: 8,
            padding: 2,
            cursor: "pointer",
            position: "relative",
          }}
        >
          <img
            onClick={() => {
              onChange(customPhoto)
            }}
            src={customPhoto}
            alt="Custom Model"
            width={35}
            height={35}
            style={{ borderRadius: 4, objectFit: "cover" }}
          />

          <Box
            style={{
              position: "absolute",
              top: -6,
              right: -6,
              zIndex: 2,
              width: 16,
              height: 16,
              background: "#fff",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              onRemoveCustomImage(image === customPhoto)
            }}
          >
            <img src="/close-sm.svg" alt="remove" width={10} height={10} />
          </Box>
        </Box>
      ) : (
        <Box
          onClick={onOpenAddCustomImageModal}
          style={{
            display: "flex",
            border: "2px solid",
            borderColor: image === customPreviewImage ? "#4945ff" : "#eaf5ff",
            borderRadius: 8,
            padding: 2,
            cursor: "pointer",
            position: "relative",
          }}
        >
          <img
            style={{ width: "35px", height: "35px", padding: "8px" }}
            src="/plus.svg"
            alt="Add custom"
          />
        </Box>
      )}
    </Box>
  )
}
